// Glass recipe — Buildings Set1 §7.4: near-white low-roughness window glass with a light
// fresnel-ish tint. The material's albedo carries the pale cyan/green of float glass and a very
// low roughness drives the tight highlight. It is rendered through the SURFACE material path with
// `transparent: true, depthWrite: false` (the SurfaceMaterialManager handles the transparency —
// the recipe itself is a plain material whose `u_opacity` is set below 1 by the renderer/clone).
// Immutable built-in root.
import {MaterialLayer, MaterialRecipe, ParamSchema} from "../@MaterialTypes.js";

export const GLASS_RECIPE_ID = "glass";

export const glassRecipe = new MaterialRecipe({
	id: GLASS_RECIPE_ID,
	name: "Glass",
	roughness: 0.04,     // near-specular
	specStrength: 1.0,   // full specular lobe (the window sheen)
	flatGeoNormal: true, // glass has no large-scale slope of its own — use straight-up geo normal so only the fresnel/sheen shades it

	params: [
		new ParamSchema({key: "glass_ramp", label: "Glass ramp", kind: "ramp", default: [0, 0.85, 0.92, 0.95, 1, 0.92, 0.97, 0.99]}),
		// Subtle broad tint variation so a big pane isn't perfectly flat.
		new ParamSchema({key: "tint_scale", label: "Tint scale (m)", kind: "scalar", min: 0.05, max: 10, default: 1.5}),
	],
	layers: [
		new MaterialLayer({
			id: "pane",
			primitive: "fbm",
			args: {
				scale: {ref: "tint_scale"},
				octaves: 3,
				lacunarity: 2,
				persistence: 0.5,
				mode: 0,
				colorRamp: {ref: "glass_ramp"},
				heightScale: 0,
			},
			blend: "over",
			contributes: "color",
		}),
	],
});
